
import { defineComponent, ref, Ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { removeQuery, updateQuery } from "../../../utils/routing_utils";

export default defineComponent({
  setup() {
    /** Instance of a router. */
    const router = useRouter();

    /** Instance of the current route. */
    const route = useRoute();

    enum FilterState {
      All,
      Selection,
    }

    /** Current state of the filters. */
    const currentState: Ref<FilterState> = ref(FilterState.All);

    watch(
        () => route.query.filterBy,
        () => {
          const select = document.getElementById(
              "selection"
          ) as HTMLSelectElement;
          if (!route.query.filterBy) {
            select.selectedIndex = 0;
          }
        }
    );

    /** Updates the URL with a new filters. */
    const changeOrder = async (event: Event): Promise<void> => {
      const input = event.target as HTMLSelectElement;

      input.focus();

      switch (Number(input.value)) {
        case FilterState.All:
          await removeQuery(router, "filterBy");
          return;
        case FilterState.Selection:
          currentState.value = FilterState.Selection;
          break;
      }

      await updateQuery(
          router,
          "filterBy",
          FilterState[currentState.value].toString()
      );
    };


    return {
      changeOrder,
    };
  },
});
